import type { DataAnalysis } from '../models';

/** 交接班（仅打印）operation_type，与 POS summary-critical-log 一致：不打开交接班详情弹窗 */
export const SENSITIVE_OP_TYPE_HAND_OVER_PRINT_ONLY = 23;

/**
 * 是否为「交接班仅打印」：不打开详情弹窗（与 POS 仅展示 operation_detail 文本一致）。
 * @param item 敏感操作列表行
 */
export function isHandOverPrintOnlyOperation(
    item: Pick<DataAnalysis, 'operation_type'> | null | undefined
): boolean {
    return Number(item?.operation_type) === SENSITIVE_OP_TYPE_HAND_OVER_PRINT_ONLY;
}

/**
 * 是否为需打开交接班详情弹窗的记录。
 * `operation_name === SHIFT` 或 type 8；排除 type 23（交接班仅打印）。
 * @param item 敏感操作列表行
 */
export function isSensitiveShiftOperation(
    item: Pick<DataAnalysis, 'operation_name' | 'operation_type'> | null | undefined
): boolean {
    if (!item || isHandOverPrintOnlyOperation(item)) {
        return false;
    }
    if (Number(item.operation_type) === 8) {
        return true;
    }
    return String(item.operation_name ?? '').toUpperCase() === 'SHIFT';
}
